import React, { memo } from 'react';

interface HelpCenterProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

function GuestProfile({ width = 64, height = 64, className = '' }: HelpCenterProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="64" height="64" fill="white" />
      <g opacity="0.64">
        <path
          d="M32 63.3332C49.3049 63.3332 63.3333 49.3048 63.3333 31.9998C63.3333 14.6949 49.3049 0.666504 32 0.666504C14.695 0.666504 0.666626 14.6949 0.666626 31.9998C0.666626 49.3048 14.695 63.3332 32 63.3332Z"
          fill="#FFD9E2"
        />
        <path
          d="M36.6164 13.092C29.1414 11.417 21.7164 16.092 20.0164 23.567C19.4164 26.217 19.6164 28.867 20.4664 31.242C20.6414 31.742 20.8414 32.242 21.0914 32.717C21.9164 34.892 23.1914 39.042 22.3664 42.267L21.1664 46.867L12.3164 47.767C12.3164 47.767 9.19143 48.192 6.21643 49.767C12.1414 58.217 22.0914 63.567 33.1664 63.067C37.4914 62.892 41.5664 61.842 45.2414 60.067C44.8914 59.492 44.4164 58.992 43.8414 58.567C40.1414 55.917 34.2914 50.942 34.2914 50.942L36.3914 43.217C36.3914 43.217 38.7414 43.817 40.1164 44.067C41.4914 44.317 42.4164 44.417 43.2914 42.417C44.4914 39.742 46.1414 33.542 46.8914 30.642C46.9914 30.342 47.0664 30.017 47.1414 29.692C47.1664 29.617 47.1664 29.517 47.1914 29.442C47.2414 29.242 47.2664 29.142 47.2664 29.142H47.2414C48.5414 21.842 43.9164 14.742 36.6164 13.092Z"
          fill="#CC8B99"
        />
        <path
          d="M63.5 32C63.5 49.397 49.397 63.5 32 63.5C14.603 63.5 0.500003 49.397 0.500001 32C0.499998 14.603 14.603 0.499995 32 0.499995C49.397 0.499995 63.5 14.603 63.5 32Z"
          stroke="#FFD9E2"
        />
      </g>
    </svg>
  );
}

export default memo(GuestProfile);
